import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './index.css';
import SiteView from './routes/DataView/DataView';
import SplashView from './routes/SplashView/SplashView';
import Admin from './components/admin/Admin';
import Deck from './components/deck/Deck';
import DeviceSetup from './components/deviceSetup/DeviceSetup';
import ReviewRedirect from './routes/Scan/Scan';
import SuperAdminBusiness from './components/superAdmin/SuperAdminBusinessControl';
import DeviceManagement from './components/SureMDM/DeviceManagement';
import Home from './components/home/Home';
import Login from './components/auth/Login';
import PrivateRoute from './components/PrivateRoute';
import { Notification } from './components/Notification';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import AcceptInvitePage from './components/AcceptInvitePage/AcceptInvitePage';
import LicensingPage from './components/Licensing/LicensingPage';
import Reporting from './routes/Reporting/Reporting';
import PollingDataView from './routes/PollingData/PollingData';
import { ToastProvider } from './components/StackedToast/StackedToast';
import 'leaflet/dist/leaflet.css';
import 'leaflet-defaulticon-compatibility';
import 'leaflet-defaulticon-compatibility/dist/leaflet-defaulticon-compatibility.css';

// PostHog setup
import posthog from './components/PostHog/posthog';
import { PostHogProvider } from 'posthog-js/react';

// testing generic modal import
import TestModalDemo from './components/genericModal/TestModalDemo';

// import header
import Header from './components/header/header';

posthog.init();

const root = ReactDOM.createRoot(document.getElementById('root'));

window.addEventListener('error', e => {
  if (e.message === 'ResizeObserver loop completed with undelivered notifications.' || 
      e.message === 'ResizeObserver loop limit exceeded') {
    const resizeObserverErrDiv = document.getElementById('webpack-dev-server-client-overlay-div');
    const resizeObserverErr = document.getElementById('webpack-dev-server-client-overlay');
    if (resizeObserverErr) {
      resizeObserverErr.setAttribute('style', 'display: none');
    }
    if (resizeObserverErrDiv) {
      resizeObserverErrDiv.setAttribute('style', 'display: none');
    }
  }
});

root.render(
  <React.StrictMode>
    <PostHogProvider
      apiKey={process.env.REACT_APP_POSTHOG_KEY}
      options={{
        api_host: process.env.REACT_APP_POSTHOG_HOST,
        capture_exceptions: true, // This enables capturing exceptions using Error Tracking
        debug: process.env.NODE_ENV === "development",
      }}
    >
      <Provider store={store}>
        <Notification />
        <ToastProvider>
        <Router>
          <Routes>
            {/* Public routes - no authentication required */}
            <Route path="/" element={<SplashView />} />
            <Route path="/login" element={<Login />} />
            
            {/* FIXED: Only one accept-invite route - PUBLIC route for invitation handling */}
            <Route path="/accept-invite" element={<AcceptInvitePage />} />
            
            {/* Public scan route - no authentication needed */}
            <Route path="/Scan/:deviceId" element={<ReviewRedirect />} />

            {/* Protected routes - wrapped with PrivateRoute */}
            <Route path="/Admin" element={
              <PrivateRoute>
                <Admin />
              </PrivateRoute>
            } />

            <Route path="/SuperAdminBusiness" element={
              <PrivateRoute>
                <SuperAdminBusiness />
              </PrivateRoute>
            } />
            
            <Route path="/Site/:storeId" element={
              <PrivateRoute>
                <SiteView />
              </PrivateRoute>
            } />
            
            <Route path="/Site" element={
              <PrivateRoute>
                <SiteView />
              </PrivateRoute>
            } />
            
            <Route path="/Deck-View" element={
              <PrivateRoute>
                <Deck />
              </PrivateRoute>
            } />

            <Route path="/Licensing" element={
              <PrivateRoute>
                <LicensingPage />
              </PrivateRoute>
            } />

            <Route path="/DeviceSetup" element={
              <PrivateRoute>
                <DeviceSetup />
              </PrivateRoute>
            } />

            <Route path='/Reporting' element={
              <PrivateRoute>
                <Reporting />
              </PrivateRoute>
            } />

            <Route path='/polling-data/:storeId' element={
              <PrivateRoute>
                <PollingDataView />
              </PrivateRoute>
            } />

            {/* Home route - protected */}
            <Route path="/Home" element={
              <PrivateRoute>
                <Home />
              </PrivateRoute>
            } />

            {/* Device Management - protected */}
            <Route path="/DeviceManagement" element={
              <PrivateRoute>
                <DeviceManagement />
              </PrivateRoute>
            } />

            {/* Test modal demo - can be removed in production */}
            {process.env.NODE_ENV === 'development' && (
              <Route path="/test-modal" element={
                <PrivateRoute>
                  <TestModalDemo />
                </PrivateRoute>
              } />
            )}

            {/* Catch-all route for 404s */}
            <Route path="*" element={
              <div style={{ 
                display: 'flex', 
                flexDirection: 'column', 
                alignItems: 'center', 
                justifyContent: 'center', 
                height: '100vh',
                fontFamily: 'system-ui, sans-serif'
              }}>
                <Header />
                <div style={{ textAlign: 'center', marginTop: '2rem' }}>
                  <h1>404 - Page Not Found</h1>
                  <p>The page you're looking for doesn't exist.</p>
                  <button 
                    onClick={() => window.location.href = '/'}
                    style={{
                      padding: '10px 20px',
                      backgroundColor: '#667eea',
                      color: 'white',
                      border: 'none',
                      borderRadius: '5px',
                      cursor: 'pointer',
                      marginTop: '1rem'
                    }}
                  >
                    Go Home
                  </button>
                </div>
              </div>
            } />

          </Routes>
        </Router>
        </ToastProvider>
      </Provider>
    </PostHogProvider>
  </React.StrictMode>
);